import { useBreadcrumbsStore } from "~/stores/breadcrumbs";

export default defineNuxtRouteMiddleware((_to, _from) => {
    const breadcrumbsStore = useBreadcrumbsStore();
    // if the route contains 'data-extraction' in its path, do not reset the breadcrumbs
    if (_to.path.includes("data-extraction")) {
        return;
    }
    // reset the breadcrumbs if there are any
    if (breadcrumbsStore.getNumberOfBreadcrumbs() > 0) {
        breadcrumbsStore.setBreadcrumbs([]);
    }
});
